import { render, staticRenderFns } from "./EntranceStaff.vue?vue&type=template&id=082e1e78&scoped=true&"
import script from "./EntranceStaff.vue?vue&type=script&lang=ts&"
export * from "./EntranceStaff.vue?vue&type=script&lang=ts&"
import style0 from "./EntranceStaff.vue?vue&type=style&index=0&id=082e1e78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082e1e78",
  null
  
)

export default component.exports